import { Component, ElementRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { GlossaryTerm, GlossaryTermDetails } from 'GlossaryApp/ts/interfaces/glossary-term.interface';

import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { UtilsService } from 'Angular/services/core/utils.service';
import { GlossaryService } from 'GlossaryApp/ts/services/glossary.service';

@Component({ standalone: false, selector: 'ycn-glossary-term', templateUrl: 'glossary-term.template.html' })
export class GlossaryTermComponent {
    internalName: string = '';

    term!: GlossaryTermDetails;

    relatedTerms: GlossaryTerm[] = [];

    glossaryHomeUrl!: string;

    sanitizedVideoLink: SafeHtml = '';

    constructor(
        private eltRef: ElementRef,
        private urlsService: UrlsService,
        private glossaryService: GlossaryService,
        private sanitizer: DomSanitizer,
        private toastMessagesService: PageToastMessagesService,
        private utilsService: UtilsService
    ) {
        this.internalName = eltRef.nativeElement.getAttribute('internalName');
        this.glossaryHomeUrl = this.urlsService.GLOSSARY.GLOSSARY_HOME;
    }

    ngOnInit(): void {
        this.glossaryService.getGlossaryTermData(this.internalName).subscribe((data) => {
            this.term = data.term;
            this.relatedTerms = data.relatedTerms;

            if (this.term.videoLink) {
                this.sanitizedVideoLink = this.sanitizer.bypassSecurityTrustHtml(this.term.videoLink);
            }
        });
    }

    navigateToDefinitionPage(term: string): void {
        if (term !== undefined) {
            window.location.href = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_TERM, { term });
        }
    }

    hasHTMLTags(input: string): boolean {
        const htmlTagPattern = /<\/?[a-z][\s\S]*>/i;
        return htmlTagPattern.test(input);
    }
}
